const initialState = {
  indicadores: null,
  cliente: null,
  clientes: [],
  visitasHistorico: [],
  loading: false
}

const comercial = (state = initialState, action) => {
  switch (action.type) {
    case 'COMERCIAL_LOADING':
      return { ...state, loading: true }
    case 'COMERCIAL_INDICADORES_FETCH':
      return { ...state, indicadores: action.payload, loading: false }
    case 'COMERCIAL_CLIENTE_FETCH':
      return { ...state, cliente: action.payload, loading: false }
    case 'COMERCIAL_CLIENTES_FETCH':
      return { ...state, clientes: action.payload, loading: false }
    case 'COMERCIAL_VISITAS_HISTORICO_FETCH':
      return { ...state, visitasHistorico: action.payload, loading: false }
    case 'COMERCIAL_VISITA_REGISTRADA':
      return { ...state, loading: false }
    default:
      return state
  }
}

export default comercial
